const Precipitation = () => {
  const data = [
    {
      month: 'Oct',
      values: [
        { value: 1.05, category: '2006-2024', month: 'Oct' },
        { value: 0.48, category: 'KAPA', month: 'Oct' },
        { value: 0.31, category: 'Cherry Ck', month: 'Oct' },
      ],
    },
    {
      month: 'Nov',
      values: [
        { value: 0.39, category: '2006-2024', month: 'Nov' },
        { value: 0.115, category: 'KAPA', month: 'Nov' },
        { value: 0.12, category: 'Cherry Ck', month: 'Nov' },
      ],
    },
    {
      month: 'Dec',
      values: [
        { value: 0.44, category: '2006-2024', month: 'Dec' },
        { value: 0.52, category: 'KAPA', month: 'Dec' },
        { value: 0.4, category: 'Cherry Ck', month: 'Dec' },
      ],
    },
    {
      month: 'Jan',
      values: [
        { value: 0.29, category: '2006-2024', month: 'Jan' },
        { value: 0.205, category: 'KAPA', month: 'Jan' },
        { value: 0.12, category: 'Cherry Ck', month: 'Jan' },
      ],
    },
    {
      month: 'Feb',
      values: [
        { value: 0.52, category: '2006-2024', month: 'Feb' },
        { value: 1.265, category: 'KAPA', month: 'Feb' },
        { value: 1.23, category: 'Cherry Ck', month: 'Feb' },
      ],
    },
    {
      month: 'Mar',
      values: [
        { value: 1.05, category: '2006-2024', month: 'Mar' },
        { value: 3.185, category: 'KAPA', month: 'Mar' },
        { value: 1.46, category: 'Cherry Ck', month: 'Mar' },
      ],
    },
    {
      month: 'Apr',
      values: [
        { value: 1.56, category: '2006-2024', month: 'Apr' },
        { value: 2.385, category: 'KAPA', month: 'Apr' },
        { value: 2.97, category: 'Cherry Ck', month: 'Apr' },
      ],
    },
    {
      month: 'May',
      values: [
        { value: 2.51, category: '2006-2024', month: 'May' },
        { value: 1.375, category: 'KAPA', month: 'May' },
        { value: 0.83, category: 'Cherry Ck', month: 'May' },
      ],
    },
    {
      month: 'Jun',
      values: [
        { value: 2.2, category: '2006-2024', month: 'Jun' },
        { value: 0.6, category: 'KAPA', month: 'Jun' },
        { value: 0.2, category: 'Cherry Ck', month: 'Jun' },
      ],
    },
    {
      month: 'Jul',
      values: [
        { value: 2.1, category: '2006-2024', month: 'Jul' },
        { value: 0.3, category: 'KAPA', month: 'Jul' },
        { value: 0.04, category: 'Cherry Ck', month: 'Jul' },
      ],
    },
    {
      month: 'Aug',
      values: [
        { value: 1.71, category: '2006-2024', month: 'Aug' },
        { value: 1.845, category: 'KAPA', month: 'Aug' },
        { value: 0.84, category: 'Cherry Ck', month: 'Aug' },
      ],
    },
    {
      month: 'Sep',
      values: [
        { value: 1.45, category: '2006-2024', month: 'Sep' },
        { value: 1.145, category: 'KAPA', month: 'Sep' },
        { value: 1.18, category: 'Cherry Ck', month: 'Sep' },
      ],
    },
  ];

  let tooltipCard;

  const createTooltip = month => {
    if (month !== null || typeof month !== 'undefined') {
      const tooltipData = data.filter(d => d.month === month);

      if (document.querySelector('.tooltip-card-precip') !== null) {
        document.querySelector('.tooltip-card-precip').remove();
      }

      tooltipCard = d3.select('body').append('div').attr('class', 'tooltip-card tooltip-card-precip');

      let html = '';
      if (tooltipData.length > 0) {
        html = `<div class="ts-tooltip-title">${tooltipData[0].month}</div>`;
        tooltipData[0].values.forEach((d, i) => {
          const legendStyle = `background: ${colors[i]}`;
          html += `
            <div class="ts-tooltip-value-wrapper">
              <div class="ts-tooltip-legend" style="${legendStyle}"></div>
              <div class="ts-tooltip-value">${d.category}: ${d.value} inches</div>
            </div>`;
        });
      }

      tooltipCard.html(html);
      const tooltipWidth = Number(tooltipCard.style('width').slice(0, -2));
      const xPos = document.body.offsetWidth / event.pageX < 1.3 ? event.pageX - (tooltipWidth + 15) : event.pageX + 15;

      tooltipCard
        .style('opacity', 1)
        .style('left', `${xPos}px`)
        .style('top', `${event.pageY - 15}px`);
    }
  };

  const removeTooltip = () => {
    tooltipCard.style('opacity', 0);
  };

  d3.select('#precip-comparison-graph-section #graph svg').remove();
  const svg = d3.select('#precip-comparison-graph-section #graph').append('svg');
  const mobile = document.body.offsetWidth < 769;

  const colors = ['#5c6bc0', '#23b578', '#dd2c00'];

  let initWidth = d3.select('#precip-comparison-graph-section #graph').style('width');
  initWidth = parseInt(initWidth.substring(0, initWidth.length - 2));
  initWidth = mobile ? initWidth * 0.85 : initWidth * 0.95;
  const initHeight = initWidth * 0.45;

  const margin = { top: 15, right: 15, bottom: 25, left: 65 };
  const width = initWidth - margin.left - margin.right;
  const height = initHeight - margin.top - margin.bottom;

  svg.attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom);

  const g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

  const x0 = d3.scaleBand().rangeRound([0, width]).paddingInner(0.1);
  const x1 = d3.scaleBand().padding(0.05);
  const y = d3.scaleLinear().rangeRound([height, 0]);

  x0.domain(data.map(d => d.month));
  x1.domain(['2006-2024 Average', 'KAPA', 'Cherry Ck']).rangeRound([0, x0.bandwidth()]);
  y.domain([0, 4]);

  g.append('g')
    .style('font-size', '18px')
    .attr('class', 'axis axis--x')
    .attr('transform', 'translate(0,' + height + ')')
    .call(d3.axisBottom(x0));

  g.append('g')
    .style('font-size', '18px')
    .attr('class', 'axis axis--y')
    .call(d3.axisLeft(y))
    .append('text')
    .attr('fill', '#000')
      .attr('y', -50)
      .attr('dy', '0.3em')
    .attr('transform', 'rotate(-90)')
    .attr('text-anchor', 'end')
    .style('font-size', '24px')
    .text('Precipitation (inches)');

  const slice = g
    .selectAll('.slice')
    .data(data)
    .enter()
    .append('g')
    .attr('class', 'g')
    .attr('transform', d => `translate(${x0(d.month)},0)`);

  slice
    .selectAll('rect')
    .data(d => d.values)
    .enter()
    .append('rect')
    .attr('width', x1.bandwidth())
    .attr('x', d => x1(d.category))
    .style('fill', '#333333')
    .style('fill', (d, i) => colors[i])
    .attr('y', d => y(d.value))
    .attr('height', d => height - y(d.value))
    .on('mouseover', function (d, i) {
      createTooltip(d.month);
    })
    .on('mouseout', function (d, i) {
      removeTooltip(removeTooltip);
    });
};
